import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnumService {
  getAnrede(anrede: number): string {
    switch (anrede) {
      case 1:
        return 'Frau';
      case 2:
        return 'Herr';
      case 3:
        return 'Divers';
      case 4:
        return 'Firma';
      case 5:
        return 'Einzelunternehmen';
      default:
        return '';
    }
  }
}
